import React from 'react';
import '../template-file-css/document-file-template.css';


export const BFCS_MstDischargeSummary = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='BFCS_MstDischargeSummary' className='file-pdf-document'>
            <div className='file-template'>
 
                <h3>MST FAMILY DISCHARGE CONTRACT </h3>
                <p className='w-750'>Congratulations to the family for successfully completing all or the majority of your overarching treatment goals in Life Changing Solutions, LLC MST program!  The MST program created this contract to help families continue their success long after the counseling has ended. The following reports/accolades confirm your progress:</p>
                <p className='w-750'>
                    <span className='eleHeader'>Observer's Report:</span> <span className='small'>(enter all key participants in services and their final report)</span>
                    <textarea id="txtObserverReport" name="txtObserverReport" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Parent's/Guardian's report on client's current behavior: </span>
                    <textarea id="txtGuardianReport" name="txtGuardianReport" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Therapist's report on client's current behavior: </span>
                    <textarea id="txtTherapistReport" name="txtTherapistReport" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Referral source's report on client's current behavior: </span>
                    <textarea id="txtReferralSource" name="txtReferralSource" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Referral Behaviors </span>
                    <span className='small'>(Problems when we started):</span>
                    <textarea id="txtReferralBehaviors" name="txtReferralBehaviors" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Your Family has demonstrated a positive change of the referral behaviors as evidenced by:</span>
                </p>
                <p className='w-750'><strong>1. Positive “fit” </strong>
                    <br />
                    <textarea id="txtPositive" name="txtPositive" className='add-only'></textarea></p>
                <p className='w-750'><strong>1. Driver's (list drivers for each positive fit)</strong><br />
                    <textarea id="txtDriver" name="txtDriver" className='add-only'></textarea></p>
                <p className='w-750'><strong>1. Steps to keep you going: </strong>
                    <br />
                    <textarea id="txtSteps" name="txtSteps" className='add-only'></textarea></p>
                <p className='w-750'><strong>2. Positive “fit” </strong>
                    <br />
                    <textarea id="txtPositive1" name="txtPositive1" className='add-only'></textarea></p>
                <p className='w-750'><strong>2. Driver's (list drivers for each positive fit)</strong><br />
                    <textarea id="txtDriver1" name="txtDriver1" className='add-only'></textarea></p>
                <p className='w-750'><strong>2. Steps to keep you going: </strong>
                    <br />
                    <textarea id="txtSteps1" name="txtSteps1" className='add-only'></textarea></p>
                <p className='w-750'><strong>3. Positive “fit” </strong>
                    <br />
                    <textarea id="txtPositive2" name="txtPositive2" className='add-only'></textarea></p>
                <p className='w-750'><strong>3. Driver's (list drivers for each positive fit)</strong><br />
                    <textarea id="txtDriver2" name="txtDriver2" className='add-only'></textarea></p>
                <p className='w-750'><strong>3. Steps to keep you going: </strong>
                    <br />
                    <textarea id="txtSteps2" name="txtSteps2" className='add-only'></textarea></p>
                <p className='w-750'><strong>4. Positive “fit” </strong>
                    <br />
                    <textarea id="txtPositive3" name="txtPositive3" className='add-only'></textarea></p>
                <p className='w-750'><strong>4. Driver's (list drivers for each positive fit)</strong><br />
                    <textarea id="txtDriver3" name="txtDriver3" className='add-only'></textarea></p>
                <p className='w-750'><strong>4. Steps to keep you going: </strong>
                    <br />
                    <textarea id="txtSteps3" name="txtSteps3" className='add-only'></textarea></p>
                <p className='w-750'><strong>5. Positive “fit” </strong>
                    <br />
                    <textarea id="txtPositive4" name="txtPositive4" className='add-only'></textarea></p>
                <p className='w-750'><strong>5. Driver's (list drivers for each positive fit)</strong><br />
                    <textarea id="txtDriver4" name="txtDriver4" className='add-only'></textarea></p>
                <p className='w-750'><strong>5. Steps to keep you going: </strong>
                    <br />
                    <textarea id="txtSteps4" name="txtSteps4" className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>What could go wrong?</span>
                    <span className='small'>(refer to fits listed above)</span>
                </p>
                <p className='w-750'><strong>1. If:</strong><br />
                    <textarea id="txtIf" name="txtIf" className='add-only'></textarea></p>
                <p className='w-750'><strong>1. Then:</strong><br />
                    <textarea id="txtThen" name="txtThen" className='add-only'></textarea></p>
                <p className='w-750'><strong>2. If:</strong><br />
                    <textarea id="txtIf1" name="txtIf1" className='add-only'></textarea></p>
                <p className='w-750'><strong>2. Then:</strong><br />
                    <textarea id="txtThen1" name="txtThen1" className='add-only'></textarea></p>
                <p className='w-750'><strong>3. If:</strong><br />
                    <textarea id="txtIf2" name="txtIf2" className='add-only'></textarea></p>
                <p className='w-750'><strong>3. Then:</strong><br />
                    <textarea id="txtThen2" name="txtThen2" className='add-only'></textarea></p>
                <p className='w-750'><strong>4. If:</strong><br />
                    <textarea id="txtIf3" name="txtIf3" className='add-only'></textarea></p>
                <p className='w-750'><strong>4. Then:</strong><br />
                    <textarea id="txtThen3" name="txtThen3" className='add-only'></textarea></p>
                <p className='w-750'><strong>5. If:</strong><br />
                    <textarea id="txtIf4" name="txtIf4" className='add-only'></textarea></p>
                <p className='w-750'><strong>5. Then:</strong><br />
                    <textarea id="txtThen4" name="txtThen4" className='add-only'></textarea></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Contact Person:
                            </span>
                            <input type="text" id="txtPrimaryContactPerson" name="txtPrimaryContactPerson" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:
                            </span>
                            <input type="text" id="txtPrimaryName" name="txtPrimaryName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone:
                            </span>
                            <input type="text" id="txtPrimaryPhone" name="txtPrimaryPhone" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Relationship to client:
                            </span>
                            <input type="text" id="txtPrimaryRelationshipClient" name="txtPrimaryRelationshipClient" className='add-only' />
                        </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Primary Address:
                    </span>
                    <textarea id="txtPrimaryAddress" name="txtPrimaryAddress" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    Follow- up with you and/or your family after discharge may include contact from our administrative or program staff at Life Changing Solutions, LLC. In the event we are unable to contact anyone at your current residence, please provide us with a second number and address.
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Secondary Contact Person:
                            </span>
                            <input type="text" id="txtSecondaryContactPerson" name="txtSecondaryContactPerson" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:
                            </span>
                            <input type="text" id="txtName" name="txtName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone: </span>
                            <input type="text" id="txtPhone" name="txtPhone" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Relationship to client: </span>
                            <input type="text" id="txtRelationshipClient" name="txtRelationshipClient" className='add-only' />
                        </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Secondary Address:
                    </span>
                    <textarea id="txtSecondaryAddress" name="txtSecondaryAddress" className='add-only'></textarea>
                </p>



            </div>
        </form>

    )
}











